import PageHero from "@/components/PageHero"
import { useScrollReveal } from "@/hooks/useScrollReveal"
import {Handshake, TrendingUp, Users, Award, CheckCircle, ArrowRight} from 'lucide-react'

const beneficios = [
  { icon: Handshake, title: "Parceria estratégica", text: "Associe sua marca a uma empresa inovadora de educação digital com impacto real na vida das pessoas.", color: "#0E8EA0" },
  { icon: TrendingUp, title: "Crescimento mútuo", text: "Desenvolva ações conjuntas que gerem valor para ambas as partes e ampliem o alcance da educação.", color: "#B038B2" },
  { icon: Users, title: "Benefício para sua base", text: "Ofereça condições exclusivas de acesso ao EW Pass para seus clientes, colaboradores ou associados.", color: "#F5C542" },
  { icon: Award, title: "Visibilidade", text: "Sua marca é divulgada nos canais da English Work, alcançando milhares de pessoas interessadas em educação.", color: "#6CC4C4" },
]

const modelos = [
  "Convênio corporativo para colaboradores",
  "Parceria institucional com universidades",
  "Co-branding e ações de marketing conjunto",
  "Patrocínio de projetos sociais",
  "Programa de benefícios para associados",
  "Eventos e workshops em parceria",
]

export default function Parceiro() {
  const section1 = useScrollReveal()
  const section2 = useScrollReveal()

  return (
    <>
      <PageHero
        title="Seja Nosso Parceiro"
        subtitle="Junte-se à English Work e transforme vidas através da educação em inglês."
      />

      <section className="py-20 bg-white">
        <div
          ref={section1.ref}
          className={`max-w-5xl mx-auto px-5 transition-all duration-700 ${section1.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <p className="text-center text-gray-600 max-w-2xl mx-auto mb-14 leading-relaxed">
            A English Work busca parceiros que compartilhem da nossa visão de democratizar o ensino de inglês no Brasil. Se sua empresa, instituição ou organização deseja fazer parte dessa missão, queremos conversar com você.
          </p>
          <div className="grid md:grid-cols-2 gap-8">
            {beneficios.map((item) => (
              <div
                key={item.title}
                className="rounded-2xl p-7 border border-gray-100 hover:shadow-lg transition-all duration-300 group"
              >
                <div
                  className="w-14 h-14 rounded-xl flex items-center justify-center mb-5 group-hover:scale-110 transition-transform"
                  style={{ backgroundColor: `${item.color}15` }}
                >
                  <item.icon size={26} style={{ color: item.color }} />
                </div>
                <h3 className="text-lg font-bold mb-2 text-gray-900">{item.title}</h3>
                <p className="text-gray-600 text-sm leading-relaxed">{item.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-20" style={{ backgroundColor: "#F8F9FA" }}>
        <div
          ref={section2.ref}
          className={`max-w-4xl mx-auto px-5 transition-all duration-700 ${section2.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10" style={{ color: "#0E8EA0" }}>
            Modelos de parceria
          </h2>
          <div className="grid md:grid-cols-2 gap-4 mb-12">
            {modelos.map((item) => (
              <div key={item} className="flex items-start gap-3 p-4 bg-white rounded-xl border border-gray-100">
                <CheckCircle size={20} className="shrink-0 mt-0.5" style={{ color: "#0E8EA0" }} />
                <span className="text-gray-700 text-sm">{item}</span>
              </div>
            ))}
          </div>
          <div className="text-center">
            <a
              href="/fale-conosco"
              className="inline-flex items-center gap-2 px-8 py-4 text-white font-bold rounded-full text-sm transition-all duration-300 hover:scale-105 hover:shadow-lg"
              style={{ backgroundColor: "#B038B2" }}
            >
              Quero ser parceiro <ArrowRight size={16} />
            </a>
          </div>
        </div>
      </section>
    </>
  )
}
